import React from 'react';
import agromate from '../assests/agromate.png';
import A2B from '../assests/A2B.png';
import ecogrow from '../assests/Ecogrow.png';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import infoproject from '../assests/Screenshot 2025-01-16 150714.png';
import softyepro from '../assests/softyepro.png';
import secureshe from '../assests/secureshe.png';

/* Developed by Arul */

const Projects = () => {
    return (
        <div className="projects" id="projects">
            <h2 className="title projects-title">Projects</h2>
            <div className="projects-container">

                <div className="project-card">
                    <a href="https://github.com/ArulG2005/intel-Hackathon-Agromate" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="fa-solid fa-arrow-right arrow" />
                    </a>

                    <img src={agromate} alt="Agromate App" className="project-image" />
                    <div className="card-description">
                        <h3>Agromate App</h3>
                        <p>This application is helpful to the farmers in farming.</p>
                        <div className="stacks">
                            <button className="tech-stack">JAVA</button>
                            <button className="tech-stack">XML</button>
                            <button className="tech-stack">Android Studio</button>
                            <button className="tech-stack">Figma</button>
                        </div>
                    </div>
                </div>



                <div className="project-card">
                    <a href="https://github.com/ArulG2005/Online-Learning-Platform-with-AI-Test-Case-Generator" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="fa-solid fa-arrow-right arrow" />
                    </a>
                    <img src={A2B} alt="Online Learning Platform with AI Test Case Generator" className="project-image" />
                    <div className="card-description">
                        <h3>Online Learning Platform with AI Test Case Generator</h3>
                        <p>This application allows users to practice coding problems and generate test cases for various input types using AI.</p>
                        <div className="stacks">
                            <button className="tech-stack">HTML</button>
                            <button className="tech-stack">CSS</button>
                            <button className="tech-stack">JavaScript</button>
                            <button className="tech-stack">Figma</button>
                        </div>
                    </div>
                </div>
                <div className="project-card">
                    <a href="https://github.com/ArulG2005/Ecogrow" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="fa-solid fa-arrow-right arrow" />
                    </a>
                    <img src={ecogrow} alt="Simple Clock WebApp" className="project-image" />
                    <div className="card-description">
                        <h3>Ecogrow</h3>
                        <p>Provide farmers with a tool to recommend crops for better yields.</p>
                        <div className="stacks">
                            <button className="tech-stack">Java</button>
                            <button className="tech-stack">Android Studio</button>
                            <button className="tech-stack">Firebase</button>
                        </div>
                    </div>
                </div>
                <div className="project-card">
                    <a href="https://github.com/ArulG2005/Expense-Management-System" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="fa-solid fa-arrow-right arrow" />
                    </a>
                    <img src={infoproject} alt="Expense Management System" className="project-image" />
                    <div className="card-description">
                        <h3>Expense Management System</h3>
                        <p>This application allows users to manage their expenses efficiently and generate reports for various spending categories with ease.</p>
                        <div className="stacks">
                            <button className="tech-stack">React JS</button>
                            <button className="tech-stack">Spring Boot</button>
                            <button className="tech-stack">Java</button>
                            <button className="tech-stack">REST API</button>
                            <button className="tech-stack">MySQL</button>
                        </div>
                    </div>
                </div>

                <div className="project-card">
                    <a href="https://www.linkedin.com/in/arul2005/" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="fa-solid fa-arrow-right arrow" />
                    </a>
                    <img src={softyepro} alt="Invoice Management System" className="project-image" />
                    <div className="card-description">
                        <h3>Invoice Management System</h3>
                        <p>This application allows users to manage invoices efficiently and generate summaries for various clients and transactions with ease.</p>
                        <div className="stacks">
                            <button className="tech-stack">React JS</button>
                            <button className="tech-stack">Node JS</button>
                            <button className="tech-stack">MongoDB</button>
                            <button className="tech-stack">REST API</button>
                            <button className="tech-stack">Express Js</button>
                        </div>
                    </div>
                </div>

                <div className="project-card">
                    <a href="https://github.com/ArulG2005/secureshe-WomanSafetyApp" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="fa-solid fa-arrow-right arrow" />
                    </a>
                    <img src={secureshe} alt="Invoice Management System" className="project-image" />
                    <div className="card-description">
                        <h3>SecureShe-WomanSafetyApp</h3>
                        <p>This application allows users to quickly send alerts, share live location, and access emergency contacts to ensure personal safety during critical situations.</p>
                        <div className="stacks">
                            <button className="tech-stack">Flutter</button>
                            <button className="tech-stack">Dart</button>
                            <button className="tech-stack">Android Studio</button>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Projects;
